<template>
  <span class="warning-popup">
    <span class="warning-popup__trigger" @click="open = true">
      <iconComponent symbol="errorOutline" width="14px" stroke="#B54708" fill="#B54708" class="warning-popup__icon" />
      <i class="warning-popup__label">{{ text }}</i>
    </span>

    <modal
      v-if="open" :header="{ closeButton: true, text: header || text }"
      @close="open = false" size="large">
      <slot>
        <div class="warning-popup__details" v-html="details"></div>
      </slot>
    </modal>
  </span>
</template>

<script>
/**
 * Inline warning that opens a modal with a longer explanation on click.
 *
 * <WarningPopup text="Mandatory client" header="Mandatory client information"
 *                details="<div>You must select a client before proceeding.</div>" />
 *
 * For richer content than a plain HTML string, pass a default slot instead of `details`.
 */
export default {
  name: 'WarningPopup',
  props: {
    // Short warning text shown inline.
    text: {
      type: String,
      required: true,
    },
    // Modal title. Defaults to `text` when omitted.
    header: {
      type: String,
      default: '',
    },
    // HTML rendered in the modal body when no default slot is provided.
    details: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      open: false,
    };
  },
};
</script>

<style lang="scss" scoped>
@use "./WarningPopup.scss";
</style>
